import React from 'react';
import { Box, Text, TextInput } from '@mantine/core';
import { IconWorld } from '@tabler/icons-react';
import { StepProps } from '../types';
import { useOnboardingStyles } from '../onboardingStyles';
import { StepVideo } from '../common';
import pageStyles from '../Onboarding.module.css';

export function Step1Domain({ data, update, errors }: StepProps) {
  const { classes } = useOnboardingStyles();

  // Changing the domain address invalidates the detected platform and any
  // previous script verification, so step 2 re-detects the updated website.
  const setField = (field: 'name' | 'url') => (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;
    if (field === 'url') {
      update({
        domain: { ...data.domain, url: value, type: '' },
        scriptVerified: false,
        scriptBypassed: false,
        shopifyConnected: false,
      });
    } else {
      update({ domain: { ...data.domain, name: value } });
    }
  };

  return (
    <Box className={`${classes.inner} ${pageStyles.stepEnter}`}>
      <div className={classes.mark}>
        <IconWorld size={28} />
      </div>
      <h1 className={classes.title}>Add your website</h1>
      <p className={classes.subtitle}>Add the primary website where you'll install Visiopt and run tests.</p>

      <StepVideo
        modalTitle="How to add your website"
        videoUrl="https://vimeo.com/1158866937"
      />

      <div className={classes.fields}>
        <TextInput
          size="md"
          radius="md"
          label="Domain Name"
          classNames={{ label: classes.fieldLabel }}
          placeholder="Example: Main Store"
          value={data.domain.name}
          error={errors.name}
          onChange={setField('name')}
        />
        <TextInput
          size="md"
          radius="md"
          label="Domain URL"
          classNames={{ label: classes.fieldLabel }}
          placeholder="Example: example.com"
          value={data.domain.url}
          error={errors.url}
          onChange={setField('url')}
        />
        <Text className={classes.tipText}>
          <span className={classes.tipLabel}>Tip:</span> Use your main website domain. You can add
          more websites later.
        </Text>
      </div>
    </Box>
  );
}
